
import videojs from "video.js";
import "video.js/dist/video-js.css";
import Badge from "./Badge.vue";
export default {
  name: "VideoPlayer",
  components: { Badge },
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    currentVideo: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      player: null,
    };
  },
  watch: {
    options() {
      this.player.src(this.options.sources);
      this.player.poster(this.options.sources[0]?.thumb);
    },
  },
  mounted() {
    // console.log(this.options);
    const nuxtInstance = this;
    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      // this.player.log("onPlayerReady", this);
      var button = videojs.getComponent("Button");
      var nextButton = videojs.extend(button, {
        constructor: function () {
          button.apply(this, arguments);
          this.controlText("Next Course");
          this.addClass("vjs-icon-next-item");
          this.addClass("custom-button-video");
        },
        handleClick: function () {
          nuxtInstance.$emit(
            "changeCurrentVideo",
            nuxtInstance.currentVideo + 1
          );
        },
      });
      var prevButton = videojs.extend(button, {
        constructor: function () {
          button.apply(this, arguments);
          this.controlText("Next Course");
          this.addClass("vjs-icon-previous-item");
          this.addClass("custom-button-video");
        },
        handleClick: function () {
          nuxtInstance.$emit(
            "changeCurrentVideo",
            nuxtInstance.currentVideo - 1
          );
        },
      });
      videojs.registerComponent("nextButton", nextButton);
      videojs.registerComponent("prevButton", prevButton);
      this.player.controlBar.addChild("prevButton", {}, 0);
      this.player.controlBar.addChild("nextButton", {}, 2);
      this.player.poster(this.options.sources[0]?.thumb);
    });
    // var video = document.createElement("video");
    // video.setAttribute("src", this.options.sources[0].src);
    // if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    //   video.muted = true;
    //   const playPromise = video.play();
    //   video.addEventListener(
    //     "loadeddata",
    //     function () {
    //       const width = video.videoWidth;
    //       const height = video.videoHeight;
    //       const ratio = width / height;
    //       const videoElement = nuxtInstance.$refs.videoPlayerWrapper;
    //       const elementWidth = videoElement.clientWidth;
    //       videoElement.style.height = `${elementWidth / ratio}px`;
    //     },
    //     false
    //   );
    //   // // Show loading animation.
    //   // if (playPromise !== undefined) {
    //   //   playPromise
    //   //     .then((_) => {
    //   //       // Automatic playback started!
    //   //       // Show playing UI.
    //   //       // We can now safely pause video...
    //   //       video.pause();
    //   //     })
    //   //     .catch((error) => {
    //   //       // Auto-play was prevented
    //   //       // Show paused UI.
    //   //     });
    //   // }
    // } else {
    //   this.$refs.videoPlayer.addEventListener(
    //     "loadedmetadata",
    //     function (e) {
    //       const width = this.videoWidth;
    //       const height = this.videoHeight;
    //       const ratio = width / height;
    //       const videoElement = nuxtInstance.$refs.videoPlayerWrapper;
    //       const elementWidth = videoElement.clientWidth;
    //       videoElement.style.height = `${elementWidth / ratio}px`;
    //     },
    //     false
    //   );
    // }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
